import React from "react";

export const Features = (props) => {
  return (
    <div id="features" className="text-center">
      <div className="container">
        <div className="col-md-10 col-md-offset-1 section-title">
          <h2>Our Clients</h2>
        </div>
        <div className="row">
          {props.data
            ? props.data.map((d, i) => (
              <div key={i} className="col-xs-6 col-md-2 client-logo">
                <img
                  src={d.logo}
                  alt={d.alt}
                  className="img-responsive center-block"
                />
              </div>
              ))
            : "Loading..."}
        </div>
      </div>
    </div>
  );
};
